<template>
  <div class="userinfo-water-mark" :style="waterMark" v-show="show"></div>
</template>
<script>
export default {
  name: "DsfUserInfoWaterMark",
  props: {
    text: {
      type: String,
      default: "",
    },
    waterMarkOptions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      textString: "",
      observer: null,
      show: true,
    };
  },
  computed: {
    waterMark() {
      let opt = Object.assign({
        fontSize: 16,
        margin: [50, 50]
      }, this.waterMarkOptions);
      let scale = 4;
      opt.fontSize *= scale;
      opt.margin[0] *= scale;
      opt.margin[1] *= scale;
      let {width, height, base64} = dsf.safe.getWaterMark(this.textString, opt);
      return {
        "background-image": `url(${base64})`,
        "background-size": `${width / scale}px ${height / scale}px`
      };
    },
  },
  beforeCreate() {},
  created() {
    if (dsf.client.lessThenIE("11")) {
      this.show = false;
    }
  },
  beforeMount() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    createImage() {
      let arr = this.text.split("\n");
      arr = _.map(arr, it => {
        return this.$replace(it);
      });
      this.textString = arr.join("\n");
    },
  },
  watch: {
    text: {
      handler(v) {
        this.createImage();
      },
      immediate: true,
    },
  },
};
</script>
